import { Trans } from 'react-i18next';

import { Alert } from '@/app/components/ui/Alert';
import { missingConfigKeys } from '@/config';

/**
 * Runtime configuration arrives from outside the bundle, so a misconfigured
 * deployment is otherwise silent until the first request fails. Nothing in the
 * scaffold needs these values yet, so this is a visible warning rather than a
 * hard failure.
 */
export function ConfigWarning() {
  const missing = missingConfigKeys();
  if (missing.length === 0) return null;

  return (
    <Alert tone="warning">
      <Trans i18nKey="shell.configWarning.body" values={{ missing: missing.join(', ') }}>
        <strong>Incomplete configuration.</strong> Missing {{ missing: missing.join(', ') }}. Set
        them in <code>.env.local</code> for local development (see <code>.env.example</code>), or in
        the container environment for a deployment.
      </Trans>
    </Alert>
  );
}
